// Play-page deep links (?product=) resolved against RecipePlugin's shop windows.
import type ExperienceData from "@/modules/ExperienceData";
import type ShopWindowConfig from "@/plugin/ShopWindowConfig";
import type ShopWindowConfigList from "@/plugin/ShopWindowConfigList";

/**
 * Finds the shop window config and swiper slide index for a product (article) id.
 * Slide indexing mirrors ArticleImageSwiper._getSlides: one opening slide (when the
 * config has one) precedes the per-article slides of cluster cindex 0.
 * The offset assumes RECIPE experiences (RecipePlugin's domain), mirroring
 * ArticleImageSwiper._getOpeningSlide semantics.
 * Returns { config, index } or null when the id is not in any shop window.
 */
export function resolveProductSlide(
  experienceData: ExperienceData,
  shopWindowConfigs: ShopWindowConfigList,
  productId: number,
): { config: ShopWindowConfig; index: number } | null {
  const configs = shopWindowConfigs.asList;
  for (let i = 0, max = configs.length; i < max; i++) {
    const swConfig = configs[i];
    if (!swConfig.hasSlides()) {
      continue;
    }
    const offset = swConfig.hasOpeningSlide(experienceData) ? 1 : 0;
    const size = experienceData.getClusterSize(swConfig.clusterName, 0);
    for (let n = 0; n < size; n++) {
      const article = experienceData.getArticle(swConfig.clusterName, 0, n);
      if (article && Number(article.id) === productId) {
        return { config: swConfig, index: n + offset };
      }
    }
  }
  return null;
}
